import React, { useContext, useEffect, useState } from "react";
import Axios from "axios";
import { useHistory } from "react-router-dom";

// Context
import AppContext from "./AppContext";
import backendURL from "./backendURL";

// Css
import "./TextEditor.css";

import BackDrop from "./BackDrop";

// Javascript
import { removeShareDiv } from "./scripts/trincotParse";

// #Icons
import TextField from "@material-ui/core/TextField";
import ShareIcon from "@material-ui/icons/Share";
import SendIcon from "@material-ui/icons/Send";
import IconButton from "@material-ui/core/IconButton";

import Zoom from "@material-ui/core/Zoom";

// Global Variable
const textLimit = 110;
let disableScroll;

function TextEditor() {
  const history = useHistory();
  const { appContext, setAppContext } = useContext(AppContext);
  const { toolBarOn } = appContext;

  // useEffect(() => {
  //   document.addEventListener("keydown", (event) => {
  //     if (
  //       document.querySelector(".textEditor").innerText.length > textLimit &&
  //       event.keyCode != 8
  //     )
  //       event.preventDefault();
  //   });

  //   document.addEventListener("paste", (event) => {
  //     const pasteDataLength = event.clipboardData.getData("Text").length;
  //     const textLength = document.querySelector(".textEditor").innerText.length;
  //     if (pasteDataLength + textLength > textLimit) event.preventDefault();
  //   });
  // }, []);

  const toogleToolBar = (state, e) => {
    if (state && e.target.className == "textEditor") {
      disableScroll = setInterval(() => {
        document.querySelector(".textEditor").scrollIntoView();
      }, 100);
      setAppContext((prev) => ({
        ...prev,
        textFocus: true,
      }));
    } else if (!state && e.target.className == "textEditor") {
      window.clearInterval(disableScroll);
      setAppContext((prev) => ({
        ...prev,
        textFocus: false,
      }));
    }
  };

  const [shareClicked, setShareClicked] = useState(false);
  const [showBackDrop, setShowBackDrop] = useState(false);
  const handleShare = async () => {
    if (!shareClicked) {
      setShareClicked(true);
    } else {
      setShowBackDrop(true);
      const htmlContent = removeShareDiv(
        document.querySelector(".textEditor").innerHTML
      );
      const clientName = document.querySelector("#clientName").value;

      await Axios.post(backendURL + "/feed", {
        name: clientName,
        content: htmlContent,
      });
      setShowBackDrop(false);
      history.push("/feed");
    }
  };

  const shareDiv = (
    <div className="shareDiv">
      <Zoom in={!toolBarOn} onClick={handleShare}>
        <div className="textEditor__share__button">
          <IconButton>
            {!shareClicked ? <ShareIcon /> : <SendIcon />}
          </IconButton>
        </div>
      </Zoom>
      <Zoom in={shareClicked}>
        <div className="textEditor__name__text">
          <TextField id="clientName" label="Name" style={{ width: "100%" }} />
        </div>
      </Zoom>
    </div>
  );

  return (
    <div>
      <div
        placeholder="Type something here..."
        oninput="if(this.innerHTML.trim()==='<br>')this.innerHTML=''"
        contentEditable={toolBarOn ? true : false}
        className={toolBarOn ? "textEditor" : "textEditor textEditor__output"}
        onFocus={(e) => {
          toogleToolBar(true, e);
        }}
        onBlur={(e) => {
          toogleToolBar(false, e);
        }}
      >
        {!toolBarOn ? shareDiv : null}
      </div>
      <BackDrop show={showBackDrop} />
    </div>
  );
}

export default TextEditor;
